export enum EGribAzfunErrors {
	UNKNOWN = 1,
	DOWNLOAD_PUBLIC_CERT,
	TOO_MANY_CERTIFICATES_ON_SERVER,
	DOWNLOAD_SIG_FILE,
	DOWNLOAD_FILE,
	FILE_MDATE,
	FTP_FILE_MDATE,
	PATH_DOES_NOT_EXIST,
	NO_FILES_IN_FOLDER,
	FILE_UPLOAD,
	SIGNATURE_INVALID,
	SIGNATURE_VALIDATION,
	SIGNATURE_NOT_FOUND,
	ERROR_RUNNING_MAIN_FUNCTION,
	NO_FILES_AT_EXPECTED_TIME,
	FILE_VALIDATOR_REGEX_MISMATCH,
	FILE_VALIDATOR_FILES_MISSING_FOR_LOCATION,
	FILE_VALIDATOR_TOO_FEW_UPDATED_FILES,
	FILE_VALIDATOR_MISSING_FILE,
	FILE_VALIDATOR_DUPLICATE_FILE,
}
